import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useApiKeyCache } from './cache'
import { type ApiKeyRemoveInput, type ApiKeyRemoveSuccess, Logger, toResponseError } from '@terros/common'

const logger = new Logger('useApiKeys')

export function useRemoveApiKey(): RemoveHookResponse<ApiKeyRemoveInput> {
  logger.verbose('calling useRemoveApiKey')
  const mutation = useTantalimMutation<ApiKeyRemoveInput, ApiKeyRemoveSuccess>({
    url: '/apikey/remove',
  })
  const cache = useApiKeyCache()

  async function remove(input: ApiKeyRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      if (!input.createdAt) return
      cache.removeItem(input.createdAt)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
